export enum UserAccessType {
    SUPER_USER = 'SUPER_USER',
    GENERAL_USER = 'GENERAL_USER',
}
